<template>
	<div class="colors">
		<div class="color" v-for="color in colors" :key="color" :style="{background: color}"></div>
	</div>
</template>

<script>
	export default {
		name: 'CaseViewColors',
		props: {
			colors: Array,
		},
	}
</script>

<style scoped>
	.colors {
		display: flex;
	}
	
	.color {
		height: 110px;
		flex: 1 1 100%;
	}
	
	@media all and (max-width: 767px) {
		.color {
			height: 70px;
		}
	}
</style>
